import _ from "lodash";
import Filter from "../../../types/Utils/Filter";
import { BuildingProjectStageEnums } from "@/enums";
import formatProjectRole from "@/utils/formatProjectRole";

export default async function (
  foundTypes?: Record<number, string>,
  foundStages?: Array<number>,
  foundCountries?: Set<string>,
  foundCalculationTypes?: Set<string>,
  foundRoles?: string[]
) {
  const filters: Array<Filter> = [];
  let ID = 0;

  // Favourite filter
  const favouriteFilter = {
    id: ID,
    value: true,
    label: "Favorites",
    filterGroup: "favorites",
    isActive: false,
  };
  filters.push(favouriteFilter);
  ID++;

  if (typeof foundTypes === "object") {
    Object.keys(foundTypes).forEach((type) => {
      const buildingType = foundTypes[Number(type)];

      if (buildingType) {
        const filter = {
          id: ID,
          label: buildingType,
          filterGroup: "type",
          isActive: false,
          value: type,
        };

        filters.push(filter);
        ID++;
      }
    });
  }

  BuildingProjectStageEnums.getValues().forEach((value) => {
    if (foundStages?.find((t) => t === value) !== undefined) {
      const filter = {
        id: ID,
        label: BuildingProjectStageEnums.getKeyFromValue(value),
        filterGroup: "stage",
        isActive: false,
        value,
      };

      filters.push(filter);
      ID++;
    }
  });

  foundCountries &&
    foundCountries.forEach((country) => {
      const filter = {
        id: ID,
        label: country,
        filterGroup: "country",
        isActive: false,
        value: country,
      };

      filters.push(filter);
      ID++;
    });

  foundCalculationTypes &&
    foundCalculationTypes.forEach((calculationType) => {
      const filter = {
        id: ID,
        label: calculationType,
        filterGroup: "calculationType",
        isActive: false,
        value: calculationType,
      };

      filters.push(filter);
      ID++;
    });

  for (const role in Object.keys(foundRoles || {})) {
    filters.push({
      id: ID,
      label: formatProjectRole(foundRoles?.[role] || "Unknown"),
      filterGroup: "role",
      isActive: false,
      value: foundRoles?.[role] || "Unknown",
    });
    ID++;
  }

  return filters;
}
